import { City, Province } from './types';
import { CityOption } from './types';

export const provinceTransform = (provinces: Province[]): CityOption[] => {
    if (!provinces || provinces.length === 0) return [];

    return provinces.reduce((cityItems, province) => {
        province.cities.forEach((city: City) => {
            cityItems.push({
                group: province.name,
                value: city.id,
                label: city.name,
            });
        });
        return cityItems;
    }, [] as CityOption[]);
};
